const AUTH_TOKEN = "auth-token";
const AUTHORIZATION = "authorization";
const getToken = () => {
  return localStorage.getItem(AUTH_TOKEN);
};

export { AUTHORIZATION, AUTH_TOKEN, getToken };
